import { render, staticRenderFns } from "./AddLeagueScores.vue?vue&type=template&id=2111e6c3&"
import script from "./AddLeagueScores.vue?vue&type=script&lang=js&"
export * from "./AddLeagueScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports